import { render, staticRenderFns } from "./coderOutpatientResponses.vue?vue&type=template&id=5480cbdd&scoped=true&"
import script from "./coderOutpatientResponses.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientResponses.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientResponses.vue?vue&type=style&index=0&id=5480cbdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480cbdd",
  null
  
)

export default component.exports